import { Injector, Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";


@Component({ template: "" })
export class FormBaseComponent implements OnInit {


  formData: any[]
  formGroupData: FormGroup


  onSubmitted = false;
  onLoading: boolean;

  checkedValue = true

  dataSources: any[];

  listTitles: any[];

  currentPage: number = 0;
  lastPage: number = 1;
  contentListLenght: string = "0"

  searchText: string = '';

  searchElement: any

  protected serviceBase: any;

  modelId: any = null

  selectedFile: File | null = null;

  selectedFiles: File[] | null = null;

  @Output() childEvent = new EventEmitter<boolean>();



  // @ViewChild('modalForm') modalForm: any;
  // @ViewChild('modalDeleteForm') modalDeleteForm: any;

  router: Router
  route: ActivatedRoute
  fb: FormBuilder

  private _messageService: MessageService;




  constructor(public injector: Injector) {
    this.router = this.injector.get(Router);
    this.route = this.injector.get(ActivatedRoute);
    this.fb = this.injector.get(FormBuilder);
    this._messageService = this.injector.get(MessageService);


  }

  ngOnInit(): void {

  }

  createFormControls() {
    const formControls = {};

    this.formData.forEach(control => {
      let validators: any[] = [];

      if (control.validations) {
        control.validations.forEach(validation => {
          if (validation.validator === 'required') {
            validators.push(Validators.required);
          } else if (validation.validator === 'email') {
            validators.push(Validators.email);
          }
        });
      }

      // Définition de la valeur par défaut du contrôle
      const defaultValue = control.defaultValue !== undefined ? control.defaultValue : '';

      // Création du contrôle avec sa valeur par défaut et ses validateurs
      formControls[control.formControlName] = [
        defaultValue,
        validators
      ];
    
    });

    return formControls;
  }


  loadForm() {
    console.log('refresh Data')
    // if (this.modalForm) {
    //   this.modelId = null
    //   this.modalForm.show()
    // } else {
    //   this.router.navigate(['/product', 'form']);

    // }

  }

  // Réagissez à l'événement émis par app-input-file
  onFileSelected(file: File) {
    // Mettez à jour le contrôle de formulaire avec le fichier sélectionné
    this.selectedFile = file;
  }

  // Réagissez à l'événement émis par app-input-file
  onFilesSelected(files: any) {
    // Mettez à jour le contrôle de formulaire avec le fichier sélectionné
    this.selectedFiles = files;
  }


  showSaveSuccesModal(propertyName: string) {
    this._messageService.add({ severity: 'success', summary: 'Succès', detail: propertyName + ' enregistré avec succès', life: 3000 });


  }


  showSaveErrorModal(propertyName) {
    this._messageService.add({ severity: 'error', summary: 'Oupss.. Problème', detail: propertyName + ' ...', life: 3000 });
  }





  // deleteFormData(data) {
  //   // this.modelId = data.name;
  //   this.modalDeleteForm.show()
  // }

  // deleteData(modelId) {
  //   this.modalDeleteForm.hide()

  //   console.log(modelId);

  // }


}
